module.exports = __webpack_public_path__ + "img/drink_2025-thumb-510x510-1577.aa017a9d.png";